export const calendarCronjobsInterval = 1000;
export const calendarTrackerStatusInterval = 1000;
